import type { InvoiceFormFields } from '@/modules/cart/domain/Cart';
import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import {
  getWeddingID,
  isWeddingFlow
} from '@/modules/shared/utils/isWeddingFlow';

const { SET_BILLING_ADDRESS_URL } = environment;

export async function createBillingAddress(
  address: InvoiceFormFields
): Promise<{ data: HttpCartDto }> {
  const isWedding = isWeddingFlow();
  const weddingId = getWeddingID();
  const url = isWedding
    ? SET_BILLING_ADDRESS_URL.replace(':idWedding', weddingId)
    : SET_BILLING_ADDRESS_URL;

  return await httpClient.post(url, {
    ...address,
    country: 'CL',
    region: address?.region + ''
  });
}
